import { ComponentProps, FC } from 'react'
import { addDisplayName, flowMax } from 'ad-hok'

import { ColorButton } from './ColorButton'

type Props = Omit<
  ComponentProps<typeof ColorButton>,
  'textColor' | 'backgroundColor'
>

export const WhiteButton: FC<Props> = flowMax(
  addDisplayName('WhiteButton'),
  (props) => (
    <ColorButton {...props} backgroundColor="white" textColor="#201F1E" />
  )
)
